import React, { Component } from 'react';

import './Modal.scss';

class Modal extends Component {

    render() {
        return (
            <div className={`Modal ${this.props.show ? 'show' : 'hide'}`}>
                <div className={`modal-overlay`} onClick={this.props.onOverlayClick}>
                    <div className={`modal-container`}>
                        <div className={'modal-close'} onClick={this.props.onCloseClick}>
                            <span>&#10005;</span>
                        </div>
                        <div className={'modal-content'}>
                            {this.props.children}
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default Modal;